import { Route } from "react-router-dom";
import Protected from "../../auth/Protected";
import { UserRole } from "../../../enums";
import PhysicalAndMentalSymptomsPage from "./physical-and-mental-symptoms-page";
import PhysicalAndMentalSymptomCreatePage from "./physical-and-mental-symptom-create-page";
import PhysicalAndMentalSymptomEditPage from "./physical-and-mental-symptom-edit-page";

export default (
  <Route path="physical-and-mental-symptoms">
    <Route
      index
      element={
        <Protected
          path="/admin/physical-and-mental-symptoms"
          roles={[UserRole.ADMIN, UserRole.SUPERADMIN]}
        >
          <PhysicalAndMentalSymptomsPage />
        </Protected>
      }
    />

    <Route
      path="create"
      element={
        <Protected
          path="/admin/physical-and-mental-symptoms/create"
          roles={[UserRole.ADMIN, UserRole.SUPERADMIN]}
        >
          <PhysicalAndMentalSymptomCreatePage />
        </Protected>
      }
    />
    
    <Route
      path="edit/:id"
      element={
        <Protected
          path="/admin/physical-and-mental-symptoms/edit/:id"
          roles={[UserRole.ADMIN, UserRole.SUPERADMIN]}
        >
          <PhysicalAndMentalSymptomEditPage />
        </Protected>
      }
    />  
  </Route>
);
